// Versão dos Termos de Serviço e da Política de Privacidade vigentes. Gravada no
// cadastro junto do aceite; atualizar junto com UPDATED_AT das páginas em pages/legal.
export const LEGAL_VERSION = '2026-10-21'
